/**
 * EV 模拟页（simulate）公用方法
 */

/** 规范化手机号关键字：仅保留数字 */
export function normalizeTelKeyword(keyword) {
  return String(keyword || "").replace(/\D/g, "");
}

/** 订单是否匹配手机号搜索（支持完整号或尾号片段） */
export function matchTelKeyword(order, keyword) {
  const key = normalizeTelKeyword(keyword);
  if (!key || !order) {
    return false;
  }
  const tel = String(order.telephone || "").replace(/\D/g, "");
  const appointTel = String(order.appointTelephone || "").replace(/\D/g, "");
  return (tel && tel.includes(key)) || (appointTel && appointTel.includes(key));
}
